import { Tooltip, TooltipProps } from '@chakra-ui/react'

export default Tooltip

export type { TooltipProps }
